import { Component, Input, OnDestroy, LOCALE_ID, Inject, Output, EventEmitter, OnInit, OnChanges,
  SimpleChanges, PLATFORM_ID, ElementRef, ChangeDetectorRef, TransferState, makeStateKey } from '@angular/core';
import { PowerReviewService } from 'src/app/common/services/power-review.service';
import { Subscription } from 'rxjs';
import { formatNumber, isPlatformBrowser } from '@angular/common';
import { MktTaggingTransformationService } from 'src/app/core/services';

const CARDS_WITH_RATINGS_KEY = makeStateKey<any[]>("cardsWithRatings");
@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-card-rating',
  standalone: false,
  template: `
  <!-- Card Rating Snippet Start -->
  <div *ngIf="!!rating && !!pid" class="cbolui-cds review-container-class">
    <div *ngIf="!hideReview" class="prSnippetMain" [attr.data-id]="'prstars-' + pid" [attr.data-pid]="pid" [attr.data-label]="title | adaFriendlyName: 'ariaLabel'">
      <div class="p-w-r text-center">
        <section data-testid="review-snippet" class="pr-review-snippet-container">
          <div class="pr-snippet-stars-reco-inline pr-snippet-minimal">
            <div class="pr-snippet-stars-reco-stars">
              <div class="pr-snippet">
                <div class="pr-snippet-stars-container">
                  <div class="pr-snippet-stars pr-snippet-stars-png">
                    <div class="pr-rating-stars" aria-hidden="true" role="presentation">
                      <div *ngFor="let star of rating.score" class="pr-star-v4 pr-star-v4-{{star}}-filled"></div>
                    </div>
                    <div aria-hidden="true" role="presentation" class="pr-snippet-rating-decimal" [innerHTML]="rating.display_rating"></div>
                    <span *ngIf="hideCount || (disableReviewModal && !scrollToSection)" class="pr-accessible-text sr-only" [innerHTML]="'rated '+rating.display_rating+' out of 5 stars '"></span>
                  </div>
                  <span *ngIf="(disableReviewModal && !scrollToSection) else linkTemplate"  [innerHTML]="' '+rating.review_count+' Reviews '"></span>
                  <ng-template #linkTemplate>
                    <a *ngIf="!hideCount" href="javascript:void(0);" tabindex="0" role="link" (click)="openModal($event); reviewTaggingCall()" (keypress)="openModal($event); reviewTaggingCall()" class="pr-snippet-review-count" [innerHTML]="rating.review_count+' Reviews '" [attr.aria-label]="title + ' rated '+rating.display_rating+' out of 5 stars and '+ rating.review_count+' Reviews ' | adaFriendlyName: 'ariaLabel'"></a>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ng-container *ngIf="!hideCount">
      <cds-modal-dialog
        [(isOpen)]="showModal"
        [ariaLabel]="title+ ' Rating & Review' | adaFriendlyName: 'ariaLabel'"
        (isOpenChange)="handleEvent($event)"
        (openStart)="handleEvent('openStart')"
        (openEnd)="handleEvent('openEnd')"
        (closeStart)="handleEvent('closeStart')"
        (closeEnd)="handleEvent('closeEnd')"
      >
      <div class="cds-modal-dialog-centered" *ngIf="showModal">
        <div class="cds-modal-content cds-modal-width">
          <div class="modal-close-button-container">
            <a href="javascript:void(0)" cdsModalInitialFocus cdsButton="inlineLink" class="modal-close-button" tabindex="0" role="button" aria-label="Close" (click)="closeModal($event, false)" role="button"
              ></a>
          </div>
          <ui-reviews-container  [pid]="pid" [hideDetailReview]="hideDetailReview"></ui-reviews-container>
          </div>
        </div>
      </cds-modal-dialog>
    </ng-container>
  </div>
  <!-- Card Rating Snippet End-->
`,
  styles: [`

  .review-container-class {
    width: 100%;
  }
  .cds-modal-dialog-centered{
    min-height:80vh;
  }
  @media screen and (max-width: 480px) {
    .cds-modal-width {
      max-width: 90vw;
     }
  }
  @media screen and (min-width: 481px) and (max-width: 1440px){
    .cds-modal-width {
      max-width: 80vw;
    }
  }
  @media screen and (min-width: 1440px){
    .cds-modal-width {
      max-width: 1024px;
    }
  }
  .prSnippetMain .p-w-r .pr-snippet-stars {
    background: transparent;
    display: inline-flex;
  }

  @media screen and (max-width: 767px){
    .prSnippetMain .p-w-r .pr-snippet-stars {
      display: flex;
    }
  }
  .p-w-r .pr-snippet-stars-reco-inline.pr-snippet-minimal .pr-snippet-stars-container a.pr-snippet-review-count {
    font-family: $font-family-bold;
    text-decoration: none;
    font-size: 14px;
    line-height:1.5;
    vertical-align:top;
  }
  .p-w-r .pr-snippet-rating-decimal {
      color: #333;
      border: 1px solid #c5c5c5;
      padding: 0 0.2em;
      font-size: 70%;
      height: 16px;
      border-radius: 0.2em;
      display: inline-block;
      vertical-align: middle;
  }
  .prSnippetMain .p-w-r .pr-snippet .pr-snippet-stars-png .pr-snippet-rating-decimal {
    padding: 0 0.2em;
    font-size: 70%;
    height: 17px;
    background: transparent;
    line-height: 1.3;
    margin-right: 5px;
    color: #333;
  }
  .prSnippetMain .p-w-r .pr-snippet .pr-snippet-stars-png .pr-rating-stars {
    visibility: visible;
    color: #000;
    background: none;
    box-sizing: border-box;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: middle;
    display: inline-flex;
    margin: 0;
  }
  .prSnippetMain .p-w-r .pr-snippet .pr-snippet-stars-png .pr-rating-stars .pr-star-v4 {
    height: 17px;
    width: 17px;
    padding: 3px;
    border-radius: 2.24px;
    margin-right: 1.6px;
    margin-left: 0;
    background-size: 17px;
  }
  .prSnippetMain .p-w-r .pr-star-v4-100-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjRjc5NDFEIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEwIDEzLjVsLTQuMTE0IDIuMTYzLjc4NS00LjU4MS0zLjMyOC0zLjI0NSA0LjYtLjY2OUwxMCAzbDIuMDU3IDQuMTY4IDQuNi42NjktMy4zMjggMy4yNDUuNzg1IDQuNTgxeiIvPjwvZz48L3N2Zz4=);
  }
  .prSnippetMain .p-w-r .pr-star-v4-0-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEwIDEzLjVsLTQuMTE0IDIuMTYzLjc4NS00LjU4MS0zLjMyOC0zLjI0NSA0LjYtLjY2OUwxMCAzbDIuMDU3IDQuMTY4IDQuNi42NjktMy4zMjggMy4yNDUuNzg1IDQuNTgxeiIvPjwvZz48L3N2Zz4=);
  }
  .prSnippetMain .p-w-r .pr-star-v4-25-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGgzdjIwSDJhMiAyIDAgMCAxLTItMlYyYTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRjc5NDFEIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEwIDEzLjVsLTQuMTE0IDIuMTYzLjc4NS00LjU4MS0zLjMyOC0zLjI0NSA0LjYtLjY2OUwxMCAzbDIuMDU3IDQuMTY4IDQuNi42NjktMy4zMjggMy4yNDUuNzg1IDQuNTgxeiIvPjwvZz48L3N2Zz4=);
  }
  .prSnippetMain .p-w-r .pr-star-v4-50-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGg4djIwSDJhMiAyIDAgMCAxLTItMlYyYTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRjc5NDFEIi8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTEwIDEzLjVsLTQuMTE0IDIuMTYzLjc4NS00LjU4MS0zLjMyOC0zLjI0NSA0LjYtLjY2OUwxMCAzbDIuMDU3IDQuMTY4IDQuNi42NjktMy4zMjggMy4yNDUuNzg1IDQuNTgxeiIvPjwvZz48L3N2Zz4=);
  }
  .prSnippetMain .p-w-r .pr-star-v4-75-filled {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cmVjdCBmaWxsPSIjREVERURFIiB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIyIi8+PHBhdGggZD0iTTIgMGgxM3YyMEgyYTIgMiAwIDAgMS0yLTJWMmEyIDIgMCAwIDEgMi0yeiIgZmlsbD0iI0Y3OTQxRCIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMCAxMy41bC00LjExNCAyLjE2My43ODUtNC41ODEtMy4zMjgtMy4yNDUgNC42LS42NjlMMTAgM2wyLjA1NyA0LjE2OCA0LjYuNjY5LTMuMzI4IDMuMjQ1Ljc4NSA0LjU4MXoiLz48L2c+PC9zdmc+);
  }
  .modal-close-button:focus{
    outline: 1px solid;
  }
  `],
  // encapsulation: ViewEncapsulation.None,
})
export class CardRatingComponent implements OnDestroy, OnInit, OnChanges {
  @Input() pid: string;
  @Input() title: string;
  @Input() hashcode:string;
  @Input() hideDetailReview: boolean = true;
  @Input() hideReview: boolean = false;
  @Input() hideCount: boolean = false;
  @Input() disableReviewModal: boolean = false;
  @Input() scrollToSection: boolean = false;
  @Input() featureId: string = '';
  @Input() reviewCount: number;
  @Input() page: string;
  @Output() handleReviewClick: EventEmitter<any> = new EventEmitter();
  @Output() handleModalEvent: EventEmitter<any> = new EventEmitter();
  @Output() reviewsTagging: EventEmitter<any> = new EventEmitter();
  private _powerReviewSub: Subscription = new Subscription();
  private cardsWithRatings = [];
  public rating: any = null;
  public showModal: boolean = false;

  constructor(
    private powerReview: PowerReviewService,
    private _elementRef: ElementRef,
    private state: TransferState,
    private _mktTagging:MktTaggingTransformationService,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(PLATFORM_ID) private platformId: string,
    private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.loadRating();
  }

  reviewTaggingCall() {
    this.reviewsTagging.emit();
    if (this.page==="CCP") {
    let taggingDynamicProp = {
      category: 'cards:acquisition',
      product_name: "c:" + this.pid,
      acquisition_source_code: this.hashcode
    }

    this._mktTagging.tagMktCompareCards('compareReviews', {
      products: [taggingDynamicProp],
      pid: this.pid,
    });
  }
  }

  loadRating() {
    if (isPlatformBrowser(this.platformId)) {
      !this.hideCount && console.log("Rating load for card =>", this.pid);
      this.rating = null;
      !!this.reviewCount && (this.rating = {
        display_rating: this.reviewCount,
        review_count: this.reviewCount,
        score: this.ratingCalculator(this.reviewCount + ".0")
      }) || this.checkAndLoadRatingsAndReviewForCard();
    }
  }

  ngOnChanges({ pid }: SimpleChanges) {
    if (!!pid.previousValue && (pid.currentValue != pid.previousValue)) {
      this.loadRating();
    }
  }

  private checkAndLoadRatingsAndReviewForCard() {
    this.cardsWithRatings = this.state.get(CARDS_WITH_RATINGS_KEY, [] as any) || [];
    if (this.cardsWithRatings.length > 0) {
      // console.log("ratings cards => : ", this.cardsWithRatings);
      this.cardsWithRatings.includes(this.pid) && this.ratingAndReviews();
    }
  }

  private ratingAndReviews() {
    this._powerReviewSub = this.powerReview.callProductSnippetReview(this.pid).subscribe(data => {
      if (!!data && data.results.length > 0) {
        const { average_rating, review_count } = data.results[0]?.rollup;
        const display_rating = formatNumber(average_rating, this.locale, '1.1-1');
        this.rating = {
          display_rating,
          review_count,
          score: this.ratingCalculator(display_rating)
        }
        this.cdr.detectChanges();
      }
    });
  }

  private ratingCalculator(rating) {
    let score = [];
    rating = parseFloat(rating);
    score.push(this.getStarScore(rating, 1));
    score.push(this.getStarScore(rating, 2));
    score.push(this.getStarScore(rating, 3));
    score.push(this.getStarScore(rating, 4));
    score.push(this.getStarScore(rating, 5));
    return score;
  }

  private getStarScore(rating, position) {
    if ((rating + 1) < position) return 0;
    return (rating >= position) ? 100 : this.getScore(rating.toString().split('.')[1]);
  }

  private getScore(number: number = 0) {
    if (number >= 0 && number < 2)
      return 0;
    else if (number >= 2 && number < 4)
      return 25;
    else if (number >= 4 && number < 6)
      return 50;
    else if (number >= 6 && number < 8)
      return 75;
    else if (number >= 8 && number <= 10)
      return 100;
  }

  public openModal(event) {
    if (!!this.rating) {
      if (this.disableReviewModal) return this.handleReviewClick.emit(event);
      this.showModal = true;
      const instance = setTimeout(() => {
        const closeRef = this._elementRef.nativeElement.querySelector('.modal-close-button');
        closeRef.focus();
        clearTimeout(instance);
      }, 1000);

    }
  }

  public closeModal(e) {
    this.showModal = false;
  }

  public handleEvent(event) {
    this.handleModalEvent.emit(event);
  }

  ngOnDestroy() {
    this.rating = undefined;
    this._powerReviewSub.unsubscribe();
  }

}
